define([
  "marionette",
  "jquery",
  "underscore",
  "messaging/messenger",
  "./refreshTokensModel",
  "./refreshTokensView",
  "./showTokenModal/showTokenModalModule",
  "modules/shared/sortableList/sortableListModule",
], function (
  Marionette,
  $,
  _,
  Messenger,
  RefreshTokensModel,
  RefreshTokensView,
  ShowTokenModalModule,
  SortableListModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userAdminRefreshTokens";
      this.namespace = options.namespace || "refreshTokens";
      this.region = options.region;
      this.user = options.user;
    },
    show: function () {
      this.refreshTokens = new RefreshTokensModel.refreshTokens();
      this.refreshTokens.fetch();
      this.view = new RefreshTokensView.layout({
        collection: this.refreshTokens,
        model: this.user,
      });
      this.tokenList = this.addSubModule(
        new SortableListModule({
          region: this.view.list,
          headers: Messenger.reqres.request("refreshTokens:headers"),
          namespace: this.namespace,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          extendedEvents: {
            "click .refresh-token-copy": this._copyRefreshToken,
            "click .refresh-token-revoke": this._revokeRefreshToken,
            "click .refresh-token-show": this._showRefreshToken,
          },
        }),
      );
      this.view.on("add:refreshToken", this._addRefreshToken, this);
      this.view.on("show", this._showSubViews, this);
      this.showRegion(this.view);
    },
    _addRefreshToken: function () {
      const refreshToken = new RefreshTokensModel.refreshToken();
      refreshToken.saveModel({
        success: (model) => {
          model.dirty = false;
          this.refreshTokens.add(model);
          Messenger.saveAttempted(true);
        },
      });
    },
    _copyRefreshToken: function () {
      // this is the ItemView for the clicked row, not the Controller
      try {
        const token = this.model.get("token");
        navigator.clipboard
          .writeText(token)
          .then(() => {
            Messenger.okDialog($.t("user.refreshToken.tokenCopiedToClipboard"));
          })
          .catch((e) => {
            console.error("Failed to copy refresh token to clipboard", e);
            Messenger.okDialog($.t("user.refreshToken.errorTokenNotCopied"));
          });
      } catch (e) {
        console.error("Failed to copy refresh token to clipboard", e);
        Messenger.okDialog($.t("user.refreshToken.errorTokenNotCopied"));
      }
    },
    _revokeRefreshToken: function () {
      // this is the ItemView for the clicked row, not the Controller
      Messenger.yesNoDialog($.t("user.refreshToken.confirmRevokeToken"), {
        yes: () => {
          this.model.set("revoked", true);
          this.model.saveModel();
        },
      });
    },
    _showRefreshToken: function (event) {
      event.preventDefault();
      // this is the ItemView for the clicked row, not the Controller
      Messenger.vent.trigger("show:modal", ShowTokenModalModule, {}, this.model, {
        title: "user.refreshToken.token",
        closeButton: true,
        closeOnBackgroundClick: true,
        modalWidth: 900,
        trackInteraction: {
          action: "Show Refresh Token",
          object: "Refresh Token",
        },
      });
    },
    _showSubViews: function () {
      this.tokenList.show(this.refreshTokens);
    },
  });
});
